import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f172a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_build-remodel-4/artifacts/hmztc857_2.png" 
                alt="J.N. Nickel Contracting Inc."
                className="h-32 w-auto invert mix-blend-lighten"
              />
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              A dedicated general contracting firm specializing in high-quality bathroom and kitchen renovations, committed to exceptional workmanship and complete client satisfaction.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-['Barlow_Condensed'] font-bold text-lg uppercase tracking-wider mb-6">
              Quick Links
            </h3>
            <nav className="flex flex-col gap-3">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/about" },
                { name: "Services", path: "/services" },
                { name: "Gallery", path: "/gallery" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-slate-400 hover:text-[#d97706] transition-colors"
                  data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-['Barlow_Condensed'] font-bold text-lg uppercase tracking-wider mb-6">
              Our Services
            </h3>
            <nav className="flex flex-col gap-3">
              {[
                "Bathroom Renovations",
                "Kitchen Renovations",
                "General Contracting",
                "Flooring Installation",
                "Drywall & Finishing",
              ].map((service) => (
                <Link
                  key={service}
                  to="/services"
                  className="text-slate-400 hover:text-[#d97706] transition-colors"
                >
                  {service}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-['Barlow_Condensed'] font-bold text-lg uppercase tracking-wider mb-6">
              Contact Us
            </h3>
            <div className="flex flex-col gap-4">
              <a 
                href="tel:+17783455884" 
                className="flex items-center gap-3 text-slate-400 hover:text-[#d97706] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-[#d97706]" />
                778-345-5884
              </a>
              <a 
                href="mailto:contact@jntile.ca" 
                className="flex items-center gap-3 text-slate-400 hover:text-[#d97706] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-[#d97706]" />
                contact@jntile.ca
              </a>
              <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <span>6002 Gladwin Rd.<br />Abbotsford, BC V4X 1V9</span>
              </div>
              <div className="flex items-start gap-3 text-slate-400">
                <Clock className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <span>Mon - Fri: 8am - 5pm</span>
              </div>
              <a 
                href="https://www.instagram.com/j_n_nickel_contracting/?hl=en" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-slate-400 hover:text-[#d97706] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5 text-[#d97706]" />
                @j_n_nickel_contracting
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} J.N Nickel Contracting. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Licensed & Insured
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
